var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"on-demand-dashboard container-fluid p-4"},[_c('kpi-boxes'),_c('demand-chart'),_c('efficiency-chart'),_c('otp-chart'),_c('usage-chart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }